import { initializeWebTracking } from '@hqo/web-tracking';
import { setUser as setSentryUser } from '@sentry/react';
import { useEffect } from 'react';
import { useSentryAnalytics } from 'app/shared/hooks/use-sentry-analytics';
import { useWebTrackingAnalytics } from 'app/shared/hooks/use-web-tracking';

export const useAnalytics = (): void => {
  const analytics = useSentryAnalytics();
  const webTrackingData = useWebTrackingAnalytics();

  useEffect(() => {
    // Sentry only indexes a top-level `id` as the searchable user id; without it the uuid stays
    // buried in `visitor` and `user.id:<uuid>` matches nothing.
    setSentryUser(analytics ? { ...analytics, id: analytics.visitor?.id } : null);
  }, [analytics]);

  useEffect(() => {
    if (webTrackingData?.currentUser && webTrackingData?.buildingUuid) {
      initializeWebTracking(
        webTrackingData?.authToken,
        webTrackingData?.buildingUuid,
        webTrackingData?.appUuid,
        navigator?.userAgent,
        webTrackingData?.clientApiUrl,
      );
    }
  }, [
    webTrackingData?.appUuid,
    webTrackingData?.buildingUuid,
    webTrackingData?.authToken,
    webTrackingData?.clientApiUrl,
    webTrackingData?.currentUser,
  ]);
};
